module.exports = __webpack_public_path__ + "img/logo_philip_morris.053721bd.png";